import React, { forwardRef, useEffect, useState } from 'react';
import ItemCompareList from "./itemCompareList";
import styled from "styled-components";

const CompareViewBottom = forwardRef((props, ref) => {
    const {itemList, bottomSize, handleScrollBottom} = props
    const {bottomTableRef ,bottomLeftTableRef} = ref
    const [isFixLeftTap, setIsFixLeftTap] = useState(false)
    const heightArr = []
    let trIndex = -1

    const handleMouseEnterLeftTap = () => {
        setIsFixLeftTap(true)
    }

    const handleMouseLeaveLeftTap = () => {
        setIsFixLeftTap(false)
    }

    useEffect(() => {
        // 하단 우측 상세정보 첫번째 tr안 td 리스트의 height값 구하여 heightArr 배열에 추가
        const element = document.querySelectorAll(".compare_list_tr_0")
        element.forEach((_,__) => {
            const elementLength = element[0].children.length - 1
            for (let j = 0; j <= elementLength; j++){
                heightArr.push(element[0].children[j]?.offsetHeight)
            }
        })

        // 하단 좌측 상세정보 첫번째 tr안 th 리스트에 height style 추가
        for (let i = 0; i <= heightArr.length-1; i++){
            const indexElement = document.getElementById(`index_${i}`)
            if (indexElement !== null) {
                indexElement.style.height = String(heightArr[i]) + "px"
            }
        }
    },[])

    return (
        <ContentBottomTable className="fix_area_bottom">
            <div className="scroll_head_top_left_wrapper">
                <div className="fix_scroll scroll_head_top"
                    ref={bottomLeftTableRef} onMouseEnter={handleMouseEnterLeftTap} onMouseLeave={handleMouseLeaveLeftTap}
                    style={{
                        height: bottomSize.height - 1,
                        overflowY: isFixLeftTap? "hidden" : "scroll"
                    }}
                >
                    <table className="content_bottom_table">
                        <tbody>
                            {itemList[0]?.spec.map(v =>
                                v.child?.map(v =>
                                    v.child?.map(v => {
                                        trIndex += 1
                                        return(
                                            <tr className={`spec_option_${v.spec_name_idx}`} id={`index_${trIndex}`} style={{position: "relative", display: "inherit"}}>
                                                <th className="title_bottom_left" style={{height: "100%"}}>
                                                    {v.name}
                                                </th>
                                            </tr>
                                        )
                                    }),
                                ),
                            )}
                            <tr className="compare_option_mall_list" style={{height: "200px"}} id={`index_${trIndex+1}`}>
                                <th className="title_bottom_left mall_list">
                                    판매처
                                </th>
                            </tr>
                            <tr className="compare_option_bottom_temp"></tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <ItemInfoTableWrapper  className="bottom_scroll_list" ref={bottomTableRef} onScroll={handleScrollBottom}>
                <table>
                    <tbody
                        className="scroll_x"
                        style={{
                            width: bottomSize.width - 72,
                            height: bottomSize.height + 16,
                        }}
                    >
                        {itemList.map((v, i) => (
                            <ItemCompareList
                                result={v}
                                index={i}
                                ref={ref}
                            />
                        ))}
                    </tbody>
                </table>
            </ItemInfoTableWrapper>
        </ContentBottomTable>
    );
});

export default CompareViewBottom;

const ItemInfoTableWrapper = styled.div`
    overflow-x: scroll;
    .scroll_x {
        position: absolute;
    }
    tbody {
        display: flex;
    }
    tr {
        display: grid;
    }
    table {
        td {
            text-align: center;
            width: 180px;
            padding: 20px 0;
            border: 1px solid #e5e5e5;
            position: relative;
            border-bottom: none;
        }
    }
`;

const ContentBottomTable = styled.div`
    display: flex;
    .scroll_head_top_left_wrapper {
        display: flex;
        flex-direction: column;
    }
    .content_bottom_table{
        width: 73px;
        table-layout: fixed;
        height: fit-content;
        border-left: 1px solid #e5e5e5;
    }
    .fix_scroll.scroll_head_top {
        width: 73px;
        border-right: 1px solid #707070;
        overflow: scroll;
        overflow-x: hidden;
    }
     .title_bottom_left{
        display: table-cell !important;
        vertical-align: middle !important;
        font-size: 12px;
         width: 73px;
         font-weight: 400;
        height: 65%;
         padding: 5px;
        background-color: #f7f7f7;
        border-bottom: 1px solid #e5e5e5;
        table-layout: fixed;
    }
    .title_bottom_left.mall_list {
        border-bottom: 1px solid #333333;
        height: 175px;
    }
    .fix_scroll {
        position: relative;
        height: 100%;
        width: 100%;
        display: flex;
    }
    .scroll_x {
        overflow-x: scroll;
    }
    .compare_option_bottom_temp {
        height: 20px;
        border-left: 1px solid white;
        border-right: 1px solid white;
    }
`;



// WEBPACK FOOTER //
// ./src/estimate_list/components/compareview/compareViewBottom.js